export default __webpack_public_path__ + "static/media/5w-40 svelt L.351b376c.png";